import _, { DebouncedFunc } from 'lodash';
import { useRef } from 'react';

interface DebouncedFunctionProps {
  debounceTime?: number;
}

const useDebounceFunction = <K>(
  { debounceTime = 60 }: DebouncedFunctionProps = { debounceTime: 60 },
) => {
  const debounceFunctionRef = useRef<DebouncedFunc<(fn: () => K) => K>>(
    _.debounce((fn: () => K) => fn(), debounceTime),
  );

  const handleDebounceFunction = debounceFunctionRef.current;

  return { handleDebounceFunction };
};

export default useDebounceFunction;
